module.exports = __webpack_public_path__ + "static/img/3.551f721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/hospital/3.png
// module id = bEhK
// module chunks = 1